import { render, staticRenderFns } from "./ProfesorPerfil.vue?vue&type=template&id=4bf5f2ae"
import script from "./ProfesorPerfil.vue?vue&type=script&lang=js"
export * from "./ProfesorPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports